import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

import React from 'react';
import { Layout } from '@/components/layout/Layout';

export function ABTestLoadingState() {
  useLanguage();
  return (
    <Layout fixedSidebar>
      <div className="p-6 flex items-center justify-center h-[80vh]">
        <div className="animate-pulse text-xl">{translateInterfaceText("Carregando...")}</div>
      </div>
    </Layout>
  );
}
